
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQSection from './FAQKeyword';
import Testimonialskeyword from './TestimonialKeyword';
function Urbaniahireforcorporate() {



    const cardData =
    {
        keyword: ' Urbania Hire for Corporate Event in Pune',
        heading: 'Samarth Travels:  Urbania Hire for Corporate Event in Pune',
        headingDescription: 'Samarth Travels offers Urbania hire for corporate events in Pune, ideal for employee transportation, business meetings, seminars, and executive group travel. Our premium Force Urbania vehicles feature air-conditioning, push-back seats, and spacious interiors to provide a professional and comfortable commute. With punctual drivers, transparent pricing, and a focus on service quality, Samarth Travels ensures a seamless and reliable travel experience for your corporate events.',

        top: 'Top Places to Visit in Pune Outstation with Samarth Travels',

      "topPlaces": [
    {
      "title": "Mahabaleshwar",
      "description": "Nestled in the Western Ghats, Mahabaleshwar is a scenic hill station around 120 km from Pune. Known for its lush strawberry farms, panoramic viewpoints like Arthur’s Seat and Wilson Point, and the historic Mahabaleshwar Temple, it offers a cool and refreshing retreat. Boating on Venna Lake and walking through misty trails make it a perfect weekend getaway."
    },
    {
      "title": "Lonavala & Khandala",
      "description": "Just about 65 km from Pune, the twin hill stations of Lonavala and Khandala are famous for their lush valleys, waterfalls, and forts like Rajmachi and Lohagad. The monsoon season enhances their charm, drawing travelers for trekking, picnics, and chikki shopping. Bhushi Dam and Tiger’s Leap are must-visit attractions in this green paradise."
    },
    {
      "title": "Shirdi",
      "description": "Located approximately 200 km from Pune, Shirdi is a revered pilgrimage town dedicated to Sai Baba. The Sai Baba Temple complex attracts millions of devotees each year. Besides the temple, other spots like Dwarkamai, Chavadi, and the Sai Heritage Village offer spiritual solace and insights into the saint’s life and teachings."
    },
    {
      "title": "Lavasa",
      "description": "Lavasa is a planned hill city about 60 km from Pune, offering Italian-style architecture and lakeside promenades. Popular for romantic getaways and weekend breaks, Lavasa features adventure sports, nature trails, and serene boat rides on the Warasgaon Lake. Its colorful buildings and vibrant cafes make it a photogenic escape."
    },
    {
      "title": "Alibaug",
      "description": "Alibaug is a coastal town around 140 km from Pune, known for its clean beaches and colonial forts. With attractions like Alibaug Beach, Kolaba Fort, and Mandwa Beach, it's a great destination for beach lovers. It’s ideal for water sports, seafood cuisine, and short family trips by road or ferry from Mumbai."
    },
    {
      "title": "Nashik",
      "description": "About 210 km from Pune, Nashik is a blend of spirituality and wine tourism. It’s home to the sacred Godavari River, Trimbakeshwar Temple, and Muktidham, making it a major religious center. Simultaneously, vineyards like Sula and York offer wine tasting and stunning vineyard views, making it a unique dual-experience destination."
    },
    {
      "title": "Kolhapur",
      "description": "Located 230 km from Pune, Kolhapur is rich in heritage, known for the Mahalaxmi Temple, New Palace Museum, and rankala Lake. It’s also famed for its spicy cuisine and handcrafted Kolhapuri chappals. A perfect cultural and culinary escape, Kolhapur provides a deep dive into Maharashtrian traditions."
    },
    {
      "title": "Bhimashankar",
      "description": "Approximately 110 km from Pune, Bhimashankar is a sacred Jyotirlinga shrine nestled in dense forests of the Sahyadri hills. Ideal for spiritual seekers and nature lovers, the region also forms part of a wildlife sanctuary. Trekking trails, misty landscapes, and temple architecture make it a soul-soothing destination."
    },
    {
      "title": "Matheran",
      "description": "Located about 120 km from Pune, Matheran is Asia’s only automobile-free hill station. Famous for its red-soiled paths, vintage toy train, and viewpoints like Panorama Point and Echo Point, it’s a tranquil retreat amidst nature. Horse rides and eco-friendly travel make it a unique experience."
    },
    {
      "title": "Goa",
      "description": "Though around 450 km away, Goa is a top outstation pick from Pune for those seeking beaches, nightlife, and Portuguese charm. From serene South Goa beaches like Palolem to lively North Goa spots like Baga and Anjuna, it’s perfect for parties, watersports, and cultural explorations. The drive or train journey adds to the adventure."
    }
  ],

"services": [
    {
        "name": "Urbania Hire for Corporate Events in Pune",
        "description": "Samarth Travels offers Urbania hire services for corporate events in Pune, providing a comfortable and professional travel solution for businesses. Whether it’s for a conference, seminar, or corporate outing, our Urbania vehicles offer spacious seating, air-conditioning, and an overall smooth travel experience for your team."
    },
    {
        "name": "Urbania Rental for Business Events Pune",
        "description": "Rent an Urbania for your next business event in Pune. Our Urbania rentals are ideal for transporting employees, clients, or business partners to and from events such as meetings, expos, or corporate dinners. With premium seating and ample space, you can ensure your team arrives in comfort and style."
    },
    {
        "name": "Rent Urbania for Corporate Travel Pune",
        "description": "For corporate travel in Pune, rent an Urbania from Samarth Travels. With a fleet of well-maintained vehicles, we ensure reliable, timely, and comfortable transportation for your business needs. Whether you're transporting employees for an offsite event or clients for a business trip, our Urbania vehicles are ideal for corporate travel."
    },
    {
        "name": "Urbania on Rent for Corporate Outings Pune",
        "description": "Planning a corporate outing in Pune? Rent an Urbania to transport your team in comfort and style. Ideal for day trips, team-building exercises, or company retreats, our Urbania vehicles are spacious, air-conditioned, and designed to provide a relaxing journey for your team members."
    },
    {
        "name": "Urbania Hire for Corporate Team-Building Events",
        "description": "Book an Urbania for your corporate team-building events. With enough space for a large team, our Urbania rentals are perfect for transporting groups to offsite locations for team-building exercises, outdoor activities, or workshops, ensuring your employees travel comfortably and arrive on time."
    },
    {
        "name": "Urbania for Corporate Travel Group Tours in Pune",
        "description": "If you're organizing a group tour for your company, our Urbania rental services are the perfect choice. Whether it’s a city tour or a visit to nearby attractions, our Urbania vehicles provide ample space, comfortable seating, and a smooth journey for your corporate group."
    },
    {
        "name": "Corporate Event Urbania Rental Services",
        "description": "Samarth Travels offers comprehensive Urbania rental services for corporate events in Pune. From conferences to award ceremonies, our vehicles can accommodate a range of corporate transportation needs, ensuring your guests travel comfortably and on time. Our professional chauffeurs and well-maintained vehicles make corporate event transportation seamless."
    },
    {
        "name": "Urbania for Corporate Meetings and Conferences Pune",
        "description": "Rent an Urbania for corporate meetings and conferences in Pune. Whether you're transporting executives, clients, or guests to a conference center or meeting venue, our Urbania rentals offer comfort, convenience, and professionalism. Enjoy a stress-free ride with ample space for all your business materials."
    },
    {
        "name": "Rent Urbania for Corporate Picnics Pune",
        "description": "For your next corporate picnic in Pune, rent an Urbania from Samarth Travels. Our vehicles are perfect for transporting teams and their picnic supplies to local parks or outdoor destinations. Enjoy a relaxed and comfortable ride while ensuring everyone arrives together in style."
    },
    {
        "name": "Urbania on Rent for Office Events in Pune",
        "description": "Make your office events easier with Urbania rentals in Pune. Whether it's a corporate dinner, employee appreciation event, or annual company gathering, our Urbania vehicles provide a comfortable, spacious ride to and from your event venue, ensuring everyone arrives together and in style."
    },
    {
        "name": "Luxury Urbania Hire for Corporate Events",
        "description": "For luxury corporate transportation in Pune, hire a luxury Urbania from Samarth Travels. Our premium vehicles offer plush seating, modern amenities, and a comfortable ride for your business guests, ensuring they travel in style and arrive refreshed for corporate events."
    },
    {
        "name": "Best Urbania Rental for Corporate Outings in Pune",
        "description": "Looking for the best Urbania rental for corporate outings in Pune? Samarth Travels offers top-quality, well-maintained Urbania vehicles, designed for comfort and efficiency. Whether it’s a company retreat or a corporate sightseeing trip, we ensure your team enjoys a smooth, relaxing journey from start to finish."
    }
],
"tableData": [
    ["Urbania Hire for Corporate Events in Pune", "Urbania Rental for Business Events Pune"],
    ["Rent Urbania for Corporate Travel Pune", "Urbania on Rent for Corporate Outings Pune"],
    ["Urbania Hire for Corporate Team-Building Events", "Urbania for Corporate Travel Group Tours in Pune"],
    ["Corporate Event Urbania Rental Services", "Urbania for Corporate Meetings and Conferences Pune"],
    ["Rent Urbania for Corporate Picnics Pune", "Urbania on Rent for Office Events in Pune"],
    ["Luxury Urbania Hire for Corporate Events", "Best Urbania Rental for Corporate Outings in Pune"]
],


"whychoose": [
    {
        "WhyChooseheading": "Reliable Force Urbania Hire for Corporate Events in Pune",
        "WhyChoosedescription": "We offer reliable and professional Force Urbania van rental services for corporate events in Pune. Whether you're organizing a business seminar, team-building activity, or company retreat, our vans ensure smooth, comfortable, and punctual transportation for your employees and clients."
    },
    {
        "WhyChooseheading": "Comfortable and Spacious Force Urbania Vans for Corporate Groups",
        "WhyChoosedescription": "Our Force Urbania vans are designed to comfortably accommodate corporate groups, with seating for up to 17 passengers. Equipped with air-conditioning, ample legroom, and comfortable seating, they provide a relaxing ride for employees, clients, or event guests traveling together."
    },
    {
        "WhyChooseheading": "Professional Drivers for Efficient Corporate Travel",
        "WhyChoosedescription": "Our skilled drivers are well-trained and professional, ensuring safe and timely transportation for your corporate event. They are familiar with Pune's routes and venues, and are dedicated to providing a smooth and hassle-free experience, with a focus on punctuality and customer service."
    },
    {
        "WhyChooseheading": "Affordable and Transparent Pricing for Corporate Rentals",
        "WhyChoosedescription": "We offer competitive and transparent pricing for corporate event rentals, with no hidden charges. Whether you need vans for a few hours or an entire day, our flexible rental packages ensure that you get high-quality service within your event's budget."
    },
    {
        "WhyChooseheading": "24/7 Availability for Corporate Event Transportation",
        "WhyChoosedescription": "Our Force Urbania vans are available 24/7, giving you the flexibility to schedule your corporate event transportation whenever it suits you. Whether it's an early morning airport pick-up or a late-night return, we ensure reliable and timely service."
    },
    {
        "WhyChooseheading": "Easy Booking and Real-Time Updates for Smooth Coordination",
        "WhyChoosedescription": "Booking your Force Urbania rental for corporate events in Pune is simple and quick. Once your booking is confirmed, you’ll receive real-time tracking information, driver contact details, and van arrival updates, making event logistics easier and more efficient."
    },
    {
        "WhyChooseheading": "Clean, Sanitized, and Well-Maintained Vans for Corporate Events",
        "WhyChoosedescription": "We maintain our Force Urbania vans to the highest standards of cleanliness and safety. Every van is thoroughly cleaned and sanitized before each corporate event, ensuring a hygienic and comfortable environment for all passengers."
    },
    {
        "WhyChooseheading": "Multiple Payment Options for Convenient Booking",
        "WhyChoosedescription": "We offer a variety of payment methods, including UPI, credit/debit cards, digital wallets, and cash, allowing you to complete your corporate event van booking easily and securely."
    }
]
























    }

const faqData = [
    {
        id: 1,
        question: 'How can I hire a Force Urbania for a corporate event in Pune?',
        answer: 'Hiring a Force Urbania for your corporate event in Pune is simple with Samarth Travels. You can book the vehicle via our website or by calling our customer support. Provide details like the number of passengers, event date, and pickup location, and we will arrange the perfect Urbania for your event.',
    },
    {
        id: 2,
        question: 'What amenities are available in the Force Urbania for corporate events?',
        answer: 'The Force Urbania for corporate events is equipped with comfortable reclining seats, air conditioning, ample luggage space, USB charging ports, reading lights, and a smooth, comfortable ride. It is designed to ensure your team travels in comfort, whether for conferences, meetings, or corporate outings.',
    },
    {
        id: 3,
        question: 'What are the rental charges for a Force Urbania for a corporate event in Pune?',
        answer: 'The rental charges for a Force Urbania for corporate events in Pune typically start from ₹35/km for a 13-seater and ₹36/km for a 17-seater. We offer custom packages based on the duration and travel distance, ensuring an affordable and convenient solution for your corporate event.',
    },
    {
        id: 4,
        question: 'Can I book a Force Urbania for a multi-day corporate event?',
        answer: 'Yes, Samarth Travels offers multi-day rentals for corporate events. You can book the Force Urbania for as many days as needed, and we will ensure that all your transportation needs are met smoothly and professionally.',
    },
    {
        id: 5,
        question: 'Can I customize the pickup and drop-off locations for my corporate event?',
        answer: 'Absolutely! Samarth Travels allows full flexibility in customizing the pickup and drop-off locations to match your event schedule and venue. Whether it’s from your office, hotel, or a specific conference location, we can accommodate your requirements.',
    },
    {
        id: 6,
        question: 'Does the rental include a driver and fuel?',
        answer: 'Yes, all Force Urbania rentals for corporate events include a professional driver and fuel. Additional costs such as toll charges or parking fees are communicated upfront for complete transparency.',
    },
    {
        id: 7,
        question: 'Is 24/7 customer support available for corporate event bookings?',
        answer: 'Yes, Samarth Travels provides 24/7 customer support for all corporate event bookings. Whether you need assistance with booking, changes in your schedule, or any other questions, our team is available to help you at any time.',
    },
];

const testimonials = [
    {
        name: 'Mr. Arvind Mehta',
        role: 'Corporate Event Manager',
        text: 'We rented a Force Urbania for our corporate retreat in Pune. The vehicle was spacious, clean, and well-equipped. The driver was professional and accommodating. It made our event transportation hassle-free and enjoyable. Highly recommend Samarth Travels!',
        image: '/img/testimonial/testi_urbania_arvind.jpg',
    },
    {
        name: 'Ms. Priya Desai',
        role: 'HR Head',
        text: 'For our corporate conference, we booked a 17-seater Force Urbania from Samarth Travels. The ride was comfortable and efficient. The van was perfect for our team, and the service was excellent. We will definitely use their services for future events.',
        image: '/img/testimonial/testi_urbania_priya.jpg',
    },
];


































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9860256019",
            "+91 9527500025",

        ],
        email: "samarthtravels9119@gmail.com"
    };


   const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: " Tempo Traveller Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: " Tempo Traveller on Rent Pune",
        },
        {
            place: "/images/keyword/3.jpg",
            text: " Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/4.jpg",
            text: " Tempo Traveller on Rent",
        },
        {
            place: "/images/keyword/5.jpg",
            text: " Tempo Traveller Rent in Pune",
        },
        {
            place: "/images/keyword/6.jpg",
            text: " Tempo Traveller Hire in Pune",
        },
        {
            place: "/images/keyword/7.jpg",
            text: " Mini Bus for Rent",
        },

        {
            place: "/images/keyword/8.jpg",
            text: " Bus on Rent Hire",
        },

        {
            place: "/images/keyword/9.jpg",
            text: " Bus on Rent Pune",
        },
        {
            place: "/images/keyword/10.jpg",
            text: " Bus Rental in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: " Hire Tempo Traveller",
        },
        {
            place: "/images/keyword/12.jpg",
            text: " Bus Hire in Pune",
        },
        {
            place: "/images/keyword/13.jpg",
            text: " Ac Tempo Traveller Rent Pune",
        },
        {
            place: "/images/keyword/14.jpg",
            text: " Bus Hire For Outstation",
        },
        {
            place: "/images/keyword/15.jpg",
            text: " Bus on Rent for Local",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Bus Rental For Wedding",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Bus Rent for Marriage",
        },
        {
            place: "/images/keyword/18.jpg",
            text: " Bus Rental For Corporate Events",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "  Bus Rental for Tour",
        },

        {
            place: "/images/keyword/20.jpg",
            text: "Bus Rental For Corporate in Pune",
        },
        {
            place: "/images/keyword/21.jpg",
            text: " Tempo Traveller on Rent in Pune",
        },
        {
            place: "/images/keyword/22.jpg",
            text: " AC Bus On Rent",
        },
        {
            place: "/images/keyword/23.jpg",
            text: " Non Ac Bus Rental Service",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Bus on Hire on Pune to Mahabaleshwar Package Tour ",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Bus Hire for Picnic",
        },
    ];


    const images = [
        { src: "/images/fleets/1.jpg", alt: "Image 1" },
        { src: "/images/fleets/2.jpg", alt: "Image 1" },
        { src: "/images/fleets/3.jpg", alt: "Image 1" },
        { src: "/images/fleets/4.jpg", alt: "Image 1" },
        { src: "/images/fleets/5.jpg", alt: "Image 1" },
        { src: "/images/fleets/6.jpg", alt: "Image 1" },
        { src: "/images/fleets/7.jpg", alt: "Image 1" },
        { src: "/images/fleets/8.jpg", alt: "Image 1" },
        { src: "/images/fleets/9.jpg", alt: "Image 1" },


    ];




const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Urbania Hire for Corporate Event in Pune",
  "image": "https://samarthtravels.com/assets/images/urbania-hire-corporate-event-pune.jpg",
  "description": "Hire Urbania for corporate events in Pune, including business meetings, conferences, team-building outings, office events, and corporate picnics. Rent luxury Urbania vehicles for your next corporate trip or group travel.",
  "brand": {
    "@type": "Brand",
    "name": "Samarth Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "5471"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "45000",
    "availability": "https://schema.org/InStock",
    "url": "https://samarthtravels.com/urbania-hire-corporate-event-pune"
  }
};





    return (
        <div>

<Helmet>
  <title>Urbania Hire for Corporate Events in Pune | Corporate Travel & Outings | Samarth Travels</title>
  <meta 
    name="description" 
    content="Rent Urbania for corporate events, meetings, team-building, office events, and picnics in Pune. Luxury vehicle hire for corporate travel and group tours." 
  />
  <meta 
    name="keywords" 
    content="Urbania hire for corporate events in Pune, Urbania rental for business events Pune, Rent Urbania for corporate travel Pune, Urbania on rent for corporate outings Pune, Urbania hire for corporate team-building events, Urbania for corporate travel group tours in Pune, Corporate event Urbania rental services, Urbania for corporate meetings and conferences Pune, Rent Urbania for corporate picnics Pune, Urbania on rent for office events in Pune, Luxury Urbania hire for corporate events" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


            <div className="breadcumb-wrapper" data-bg-src="/images/breadcumb-bg.jpg">
                <div className="container">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title text-center">{cardData.keyword}</h1>
                    </div>
                </div>
            </div>



            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/50.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2 bg-foootr'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Samarth Travels </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">


                                                <FAQSection faqs={faqData} accordionId="drivingAccordion" />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <Testimonialskeyword
                                data={testimonials}
                                title="What Our Clients Are Saying"
                                subtitle="Customer Feedback"
                            />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #FF8F1F',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#FF8F1F' }}>
                                            <h4 className=" lead fw-semibold whitt textt-dark">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919860256019" className="d-block  text-white">+91 9860256019</a>
                                                <a href="tel:+919527500025" className="d-block  text-white">+91 9527500025</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#FF8F1F' }}>
                                                <h4 className=" fw-semibold lead whitt textt-dark">Email</h4>
                                                <a href="mailto:samarthtravels9119@gmail.com" className=" text-white d-block">
                                                    samarthtravels9119@gmail.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#FF8F1F' }}>
                                                <h4 className=" fw-semibold lead whitt textt-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Samarth Travels <br />
                                                        Flat no 201, Juhi Building, Suyash Shrushti Society, Tukai darshan Hadapsar, Pune- 411028
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Urbaniahireforcorporate;